export default {"src":"/login-app/[GIT_HASH]/_next/static/media/table_rows.db0148c3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};